<ion-header
  class="ion-no-border ion-header-modal-mobile"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="(platformService?.isTouchExperience$ | async) === false"
        id="close-modal-btn"
        data-cy="close-sort-filter-modal-button"
        (click)="onClose()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="filter-label">
      {{ 'i18n.lists.filter' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <!-- Mobile Version -->
  <div
    *ngIf="platformService?.isTouchExperience$ | async"
    class="filter-options"
  >
    <ion-item
      *ngFor="let option of options"
      [class.selected]="option.selected"
      (click)="toggleOption(option)"
      data-cy="filter-option-{{ option.id }}"
      lines="none"
    >
      <ion-label
        [id]="option.id"
        class="filter-option"
        data-cy="filter-option-label-{{ option.id }}"
      >
        {{ option.label | translate }}
      </ion-label>
      <app-usf-checkbox
        [attr.aria-labelledby]="option.id"
        [invertColors]="true"
        [isSelected]="option.selected"
        data-cy="filter-option-checkbox-{{ option.id }}"
      ></app-usf-checkbox>
    </ion-item>
  </div>

  <!-- Desktop Version -->
  <div
    *ngIf="(platformService?.isTouchExperience$ | async) === false"
    class="sort-filter-list-options"
  >
    <ion-item
      *ngFor="let option of options"
      [class.selected]="option.selected"
      (click)="toggleOption(option)"
      data-cy="filter-option-{{ option.id }}"
    >
      <div class="item-content">
        <ion-label
          [id]="option.id"
          class="filter-option"
          data-cy="filter-option-label-{{ option.id }}"
        >
          {{ option.label | translate }}
        </ion-label>
        <ion-checkbox
          [attr.aria-labelledby]="option.id"
          [checked]="option.selected"
          data-cy="filter-option-checkbox-{{ option.id }}"
        ></ion-checkbox>
      </div>
    </ion-item>
  </div>
</ion-content>

<ion-footer
  [ngClass]="
    (platformService?.isTouchExperience$ | async) &&
    platformService?.platformType === platformService?.platformEnum?.mobile
      ? 'ion-footer-modal-mobile'
      : 'ion-footer-modal'
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="clear-all-modal-btn"
        data-cy="clear-all-sort-filter-modal-button"
        [ngClass]="
          (platformService?.isTouchExperience$ | async)
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="onClearAll()"
      >
        {{ 'i18n.common.clearAll' | translate }}
      </ion-button>
      <ion-button
        id="apply-modal-btn"
        data-cy="apply-sort-filter-modal-button"
        [ngClass]="
          (platformService?.isTouchExperience$ | async)
            ? 'usf-fill-green-mobile-modal-button'
            : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        [disabled]="!hasChanges()"
        (click)="onSave()"
      >
        {{ 'i18n.lists.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
